<div class="cookie-modal-wrapper">
  <div [@appearSlowlyAnimation] class="bottom-modal" id="modal-description"
    role="dialog">
    <div [ngClass]="isMobile ? 'mobile-css' : 'desktop-css'"
      class="bottom-modal-body white-bg">
      <div>
        <div class="bottom-modal-img-container">
          <img alt="important" class="bottom-modal-img" height="46"
            loading="lazy" ngSrc="assets/scalableVectorGraphics/important.svg" width="46">
          </div>
          <div class="consent-text">
            <span [innerHTML]="content" class="mt-2" style="white-space: pre-line"></span>
            @if (checkboxName !== 'termsConsent') {
              <div class="text-center mt-4">
                <u><a (click)="expandText = !expandText" class='link-color text-center' tabindex="0">
                {{ expandText ? ("shared.readLess" | translate) : "shared.readMore" | translate }}</a></u>
              </div>
            }

            @if (expandText) {
              <div [innerHTML]="'shared.whyWeNeedConsentText' | translate" appLinkHandler class="mt-4"></div>
            }

            <div [ngClass]="{'bottom-modal-btn-container-mobile': isMobile}" class="bottom-modal-btn-container my-4">
              <button (click)="onRemove()"
                class="btn bottom-modal-btn bottom-modal-remove-btn mt-2">
                <div class="remove-button-text">{{ "shared.removeConsent" | translate }}</div>
              </button>

              <button (click)="onCancel()"
                class="btn bottom-modal-btn bottom-modal-not-accept-btn mt-2">{{ "shared.back" | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
